<ng-container *transloco="let t">
    <!-- Loading bar -->
    <fuse-loading-bar></fuse-loading-bar>

    <!-- Navigation -->
    <fuse-vertical-navigation
        class="dark bg-[#030f1b] print:hidden"
        [showFadeOnRight]="false"
        [mode]="isScreenMedium || isScreenSmall || isScreenLarge || isKioskMode ? 'over' : 'side'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="!isScreenMedium && !isScreenSmall && !isScreenLarge && !isKioskMode">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <div class="flex w-full items-center justify-between p-4">
                <div class="relative flex flex-col">
                    <!-- Logo -->
                    <img src="/images/logo/logo.png" class="max-h-22 w-auto pl-3" alt="" />
                    <span class="text-secondary absolute -bottom-7 left-3 w-50 select-none" *ngIf="isKioskMode">{{
                        'general.kiosk_mode_enabled' | transloco
                    }}</span>
                </div>

                <button
                    [matMenuTriggerFor]="settingsMenu"
                    data-testid="profile-button"
                    class="hover:bg-token-main-surface-secondary focus-visible:bg-token-main-surface-secondary z-99 flex h-10 w-10 items-center justify-center rounded-full text-[#525252] transition-all duration-1000 ease-in-out hover:rotate-180 focus-visible:outline-0"
                    type="button"
                    id="radix-:rdm:"
                    aria-haspopup="menu"
                    aria-expanded="false"
                    data-state="closed">
                    <div class="flex items-center justify-center overflow-hidden rounded-full">
                        <mat-icon class="icon-size-8" [svgIcon]="'heroicons_outline:cog-6-tooth'"></mat-icon>
                    </div>
                </button>

                <!-- Mat menu -->
                <mat-menu #settingsMenu="matMenu" class="ml-10 min-w-100 rounded-xl p-4">
                    <div class="relative flex flex-col items-center justify-center p-5">
                        <!-- Icon with name and lastname inital letters -->
                        <div
                            class="flex h-20 w-20 cursor-default select-none items-center justify-center rounded-full bg-gray-800 text-4xl font-semibold text-white transition-all duration-500 hover:scale-110 dark:bg-gray-600">
                            {{ profile?.firstName?.charAt(0) }}{{ profile?.lastName?.charAt(0) }}
                        </div>

                        <div class="mt-2 flex flex-col items-center">
                            <span class="text-lg text-gray-600 dark:text-white">{{ profile?.firstName }} {{ profile?.lastName }}</span>
                            <span class="text-sm text-gray-400">{{ profile?.email }}</span>
                            <a class="cursor-pointer text-xs text-blue-500 underline" (click)="passwordChange()">{{
                                t('general.change_password')
                            }}</a>
                        </div>
                    </div>

                    <div class="flex w-full min-w-60 flex-col items-center justify-center rounded-md bg-[#f0f0f0] p-2 px-4 py-5">
                        <span class="text-secondary mb-2 flex items-center gap-2 text-lg font-semibold">
                            {{ t('general.account') }}
                        </span>

                        <!-- Gestisci account -->
                        <button mat-menu-item (click)="openAccountManagement()">
                            <mat-icon class="icon-size-4" svgIcon="heroicons_outline:user"></mat-icon>
                            {{ t('general.profile') }}
                        </button>

                        <!-- Language switcher -->
                        <button mat-menu-item (click)="switchLanguage()">
                            <mat-icon class="icon-size-4">language</mat-icon>
                            <span>{{ currentLang === 'it' ? 'English' : 'Italiano' }}</span>
                        </button>

                        <!-- Menu Logout -->
                        <button mat-menu-item (click)="logout()">
                            <mat-icon class="icon-size-4">logout</mat-icon>
                            <span>{{ t('general.logout') }}</span>
                        </button>
                    </div>
                </mat-menu>
            </div>

            <!-- spacer -->
            <div class="flex min-h-4 flex-1"></div>
        </ng-container>

        <ng-container fuseVerticalNavigationFooter>
            <!-- Footer -->
            <div
                class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 md:px-6 dark:bg-transparent print:hidden">
                <ng-container *transloco="let t">
                    <span [routerLink]="'/changelog'" class="block cursor-pointer text-center text-xs text-blue-500 underline">
                        {{ t('application.name') }} &copy; {{ currentYear }} - <app-application-version
                    /></span>
                </ng-container>
            </div>
        </ng-container>
    </fuse-vertical-navigation>

    <!-- Wrapper -->
    <div class="flex min-h-0 w-full flex-1 flex-col overflow-hidden bg-white">
        <!-- Impersonation banner -->
        @if (impersonationService.isImpersonating) {
            <div class="flex items-center justify-between bg-amber-500 px-4 py-2 text-sm font-medium text-white shadow-md">
                <div class="flex items-center gap-2">
                    <mat-icon class="icon-size-5">visibility</mat-icon>
                    <span>
                        {{ t('general.impersonating') }}
                        <strong
                            >{{ impersonationService.currentState?.firstName }} {{ impersonationService.currentState?.lastName }}</strong
                        >
                        ({{ impersonationService.currentState?.email }})
                    </span>
                </div>
                <button mat-flat-button class="!bg-white !text-amber-700 hover:!bg-amber-50" (click)="stopImpersonation()">
                    <mat-icon class="mr-1 icon-size-4">close</mat-icon>
                    {{ t('general.stop_impersonation') }}
                </button>
            </div>
        }
        @if (true) {
            <app-header class="shrink-0"></app-header>
            <!-- Content - Scrollable Area -->
            <div class="min-h-0 flex-1 overflow-y-auto">
                <router-outlet></router-outlet>
            </div>
        }
    </div>

    <!-- Quick chat -->
    <!-- <quick-chat #quickChat="quickChat"></quick-chat> -->

    <div class="snackbar-wrapper pointer-events-none absolute inset-0 h-screen w-screen overflow-hidden">
        <div class="absolute right-5 top-5 z-99999 flex flex-col gap-2 overflow-visible transition-all duration-500 ease-in-out">
            <fuse-alert
                *ngFor="let snackbar of snackbarProps; index as i"
                [id]="'snackbar-' + i"
                [name]="'snackbar' + snackbar.uniqueId"
                class="pointer-events-auto absolute right-5 min-w-100 max-w-100 transition-all duration-500 ease-in-out"
                [style]="calculateTopSpace(i)"
                [dismissible]="true"
                (dismissedChanged)="dismissed(snackbar.uniqueId)"
                [appearance]="'fill'"
                [type]="snackbar?.type || 'info'"
                @slideInRight
                @slideOutRight>
                <span fuseAlertTitle class="">{{ snackbar?.title }}</span>
                <div [ngClass]="{ '-mt-1': !snackbar.title }" [innerHTML]="snackbar?.message"></div>
            </fuse-alert>
        </div>
    </div>
</ng-container>
